import React, { useContext, useEffect, useState } from 'react';
import { SalesforceContext } from 'src/context/salesforce-context';
import { Modal } from 'src/components';
import './device-quantity-change-conflict-resolver.scss';

export default function DeviceQuantityChangeConflictResolver({
  deviceId,
  deviceQuantity,
  deviceQuantityChangeAcceptCallback,
  deviceQuantityChangeRejectCallback,
}) {
  const { ensureDeliveryQuantityMatchesOrderQuantity } = useContext(SalesforceContext);

  const [showConfirmQuantityReduce, setShowConfirmQuantityReduce] = useState(false);

  useEffect(() => {
    setShowConfirmQuantityReduce(!!deviceId);
  }, [deviceId]);

  const handleReduceDeviceQuantityConfirm = () => {
    ensureDeliveryQuantityMatchesOrderQuantity(deviceId, deviceQuantity);
    deviceQuantityChangeAcceptCallback(deviceId, deviceQuantity);
    setShowConfirmQuantityReduce(false);
  };

  const handleReduceDeviceQuantityReject = () => {
    deviceQuantityChangeRejectCallback();
    setShowConfirmQuantityReduce(false);
  };

  const ResolveModal = (props) => {
    return (
      <Modal
        modalStyle="ResolveModal"
        show={props.show}
        cardStyle="resolve-modal-card"
        header={() => (
          <p className="resolve-modal-head heading-four has-text-centered">{props.title}</p>
        )}
        headerStyle="resolve-modal-card-head"
        body={() => props.body()}
        bodyStyle="resolve-modal-card-body has-text-centered"
        footer={() => props.footer()}
        footerStyle="resolve-modal-card-foot"
        backdropStyle="backdrop"
      />
    );
  };

  return (
    <div className="DeviceQuantityChangeConflictResolver">
      <ResolveModal
        show={showConfirmQuantityReduce}
        title="Reduce quantity?"
        body={() => (
          <p className="content-large-extra">
            This will remove devices from your delivery addresses starting from the last added
            address.
            <div className="red-line" />
          </p>
        )}
        footer={() => (
          <div className="columns">
            <div className="column is-half">
              <button
                className={'button is-pulled-left no-button'}
                automationid="Onboarding_Choose_Solution_Button_Reduce_Delivery_Quantity_Yes"
                onClick={() => handleReduceDeviceQuantityReject()}
              >
                Cancel
              </button>
            </div>
            <div className="column is-half">
              <button
                className={'button is-primary is-pulled-right'}
                automationid="Onboarding_Choose_Solution_Button_Reduce_Delivery_Quantity_Yes"
                onClick={() => handleReduceDeviceQuantityConfirm()}
              >
                Reduce quantity
              </button>
            </div>
          </div>
        )}
      />
    </div>
  );
}
